export type MercadoPagoPaymentStatus =
  | 'pending'
  | 'approved'
  | 'processed'
  | 'failed'
  | 'canceled'
  | 'expired';

export interface MercadoPagoStatusPayload {
  message?: string;
  orderId?: string;
  paymentStatus?: MercadoPagoPaymentStatus | string;
  paymentStatusDetail?: string | null;
}

export interface MercadoPagoStatusResult {
  finalizado: boolean;
  pago: boolean;
  mensagem?: string;
}

function mensagemPagamentoRecusado(statusDetail?: string | null): string {
  switch (statusDetail) {
    case 'card_disabled':
      return 'Cartão bloqueado ou desabilitado. Tente outro cartão ou forma de pagamento.';
    case 'insufficient_amount':
      return 'Saldo ou limite insuficiente. Tente outro cartão ou forma de pagamento.';
    case 'amount_limit_exceeded':
      return 'O valor excede o limite permitido. Tente outro cartão ou forma de pagamento.';
    case 'required_call_for_authorize':
      return 'O cartão precisa de autorização do emissor. Tente outro cartão ou forma de pagamento.';
    case 'max_attempts_exceeded':
      return 'Limite de tentativas excedido. Tente outro cartão ou forma de pagamento.';
    default:
      return 'Pagamento recusado. Tente outro cartão ou forma de pagamento.';
  }
}

export function resolverStatusPagamentoMercadoPago(
  payload: MercadoPagoStatusPayload
): MercadoPagoStatusResult {
  const paymentStatus = payload.paymentStatus
    || (payload.message === 'pagou' ? 'approved' : 'pending');

  if (paymentStatus === 'approved' || paymentStatus === 'processed') {
    return { finalizado: true, pago: true };
  }

  if (paymentStatus === 'failed') {
    return {
      finalizado: true,
      pago: false,
      mensagem: mensagemPagamentoRecusado(payload.paymentStatusDetail)
    };
  }

  if (paymentStatus === 'canceled') {
    return {
      finalizado: true,
      pago: false,
      mensagem: 'Pagamento cancelado. Você pode tentar novamente.'
    };
  }

  if (paymentStatus === 'expired') {
    return {
      finalizado: true,
      pago: false,
      mensagem: 'Pagamento expirado. Tente novamente.'
    };
  }

  return { finalizado: false, pago: false };
}
